(function () {
  'use strict';

  var STAGGER_MS = 80; // 要素間の時間差（ms）

  // アニメーション対象とするセレクター
  // セクション内の直接コンテンツ要素を自動検出
  var TARGET_SELECTOR = [
    '[data-testid="section-content"] > *',
    '.custom-section-content > *',
    '[data-fade]'
  ].join(', ');

  function init() {
    // FVセクション（最初の .shopify-section）を除外
    var allSections = document.querySelectorAll('.shopify-section');
    var fvSection = allSections[0] || null;

    var targets = Array.prototype.filter.call(
      document.querySelectorAll(TARGET_SELECTOR),
      function (el) {
        // FV内は除外
        if (fvSection && fvSection.contains(el)) return false;
        // すでにis-visibleがついている要素は除外
        if (el.classList.contains('is-visible')) return false;
        return true;
      }
    );

    if (!targets.length) return;

    // CSSクラスを付与して初期状態（非表示）にする
    targets.forEach(function (el) {
      el.classList.add('fade-target');
    });

    // 親ごとにグループ化してstagger delayを付与
    var parentMap = new Map();
    targets.forEach(function (el) {
      var parent = el.parentElement;
      if (!parentMap.has(parent)) parentMap.set(parent, []);
      parentMap.get(parent).push(el);
    });

    parentMap.forEach(function (children) {
      children.forEach(function (el, i) {
        el.style.setProperty('--fade-delay', i * STAGGER_MS + 'ms');
      });
    });

    // Intersection Observer — 一度表示したら unobserve
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.08 }
    );

    targets.forEach(function (el) {
      observer.observe(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
